import Button from '@platform-ui-common/components/Button/index.js';
import Link from '@platform-ui-common/components/Link/index.js';
import Loading from '@platform-ui-common/components/Loading/index.js';
import Message from '@platform-ui-common/components/Message/index.js';
import TextInput from '@platform-ui-common/components/TextInput/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { isSignInWithEmailLink } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat';
import { IdentityPaths } from '../Routes.js';
import { firebaseErrorDisplay } from '../utils/errors.js';

function MagicLink() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');

  const {
    identity: {
      auth,
      signinMethods: { emailLinkAuth },
    },
    resetAuthState,
  } = useAuth();

  const [email, setEmail] = useState(window.localStorage.getItem('signinEmail') ?? '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmailPrompt, setShowEmailPrompt] = useState(false);

  const trySubmit = () => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      setLoading(true);
      resetAuthState()
        .then(() => {
          emailLinkAuth({ email, link: window.location.href })
            .then(() => {
              window.localStorage.removeItem('signinEmail');
              if (redirectUrl) {
                window.location.assign(redirectUrl);
              } else {
                navigate(ApplicantRoutes.APPLICATION_PORTAL, { replace: true });
              }
              setLoading(false);
            })
            .catch((error) => {
              setError(firebaseErrorDisplay(error ?? 'Something went wrong'));
              setLoading(false);
            });
        })
        .catch((error) => {
          setError(firebaseErrorDisplay(error ?? 'Something went wrong'));
          setLoading(false);
        });
    } else {
      setError('The signin link was invalid');
    }
  };

  useEffect(() => {
    if (error || loading || auth?.currentUser) return;
    if (!email) {
      setShowEmailPrompt(true);
      return;
    }
    if (!showEmailPrompt) return trySubmit();
  });

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center gap-6">
        <Typography variant="h2">There was an issue using the magic link:</Typography>
        <div>
          <Message variant="error">{error}</Message>
        </div>
        <Typography variant="body">
          Links expire after 1 hour. Please click the link below to go back to the sign in page and
          try again.
        </Typography>
        <Link to={IdentityPaths.SIGNIN}>Click here to try signing in again</Link>
      </div>
    );
  }

  if (showEmailPrompt) {
    return (
      <div className="flex flex-col items-center justify-center gap-6">
        <Typography variant="h2">Please confirm your email address to complete sign in:</Typography>
        <form className="flex flex-col gap-4">
          <TextInput
            id={'email'}
            label={'Email'}
            type="email"
            value={email}
            onChange={(val) => setEmail(val)}
          />
          <Button onClick={trySubmit}>Submit</Button>
        </form>
      </div>
    );
  }

  return <Loading size="XXL" fullPage />;
}

export default MagicLink;
